export const globalPageSizeOptions = [10, 10, 20, 50];
